import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'

Vue.use(Vuex)

export const config = {
  mutations,
  state
}

export default new Vuex.Store(config)



// WEBPACK FOOTER //
// ./src/store/index.js